module.exports = __webpack_public_path__ + "img/infos_travel.ee02f65a.jpg";